// Chart colors - single source of truth for chart bars and legend dots
export const CHART_COLORS = {
  normal: '#9e9e9e',
  boost: '#19bcc9',
  gridLine: '#eee',
}

// Time periods
export const DAYS_TOTAL = 90
export const DAYS_PER_PAGE = 30

// Breakpoints
export const MOBILE_BREAKPOINT = 768

// Metric types
export const METRIC_TYPES = {
  views: 'views',
  earnings: 'earnings',
}
